import { render, staticRenderFns } from "./ImageManager.vue?vue&type=template&id=c243f316&scoped=true&"
import script from "./ImageManager.vue?vue&type=script&lang=ts&"
export * from "./ImageManager.vue?vue&type=script&lang=ts&"
import style0 from "./ImageManager.vue?vue&type=style&index=0&id=c243f316&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c243f316",
  null
  
)

export default component.exports